<template>
  <Transition name="afp-cookie-fade">
    <div
      v-if="visible"
      class="afp-cookie-banner shadow-lg"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
    >
      <div class="afp-cookie-content">
        <p class="afp-cookie-text mb-0">
          We use cookies to keep you signed in and to protect our forms from abuse.
          By continuing to use this site, you accept our use of essential and
          security-related cookies.
        </p>
        <div class="afp-cookie-actions">
          <MDBBtn color="primary" size="sm" @click="accept">Accept</MDBBtn>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { MDBBtn } from 'mdb-vue-ui-kit'

const STORAGE_KEY = 'afp-cookie-consent'

const visible = ref(false)

onMounted(() => {
  try {
    if (localStorage.getItem(STORAGE_KEY) !== 'accepted') {
      visible.value = true
    }
  } catch {
    // localStorage unavailable (e.g. private mode) — show the banner anyway
    visible.value = true
  }
})

function accept() {
  try {
    localStorage.setItem(STORAGE_KEY, 'accepted')
  } catch {
    // ignore persistence failures
  }
  visible.value = false
}
</script>

<style scoped>
.afp-cookie-banner {
  position: fixed;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  z-index: 1080;
  margin: 0 auto;
  max-width: 960px;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  background: #0c1728;
  border: 1px solid var(--mdb-border-color, rgba(255, 255, 255, 0.12));
}

.afp-cookie-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.afp-cookie-text {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
}

.afp-cookie-actions {
  flex-shrink: 0;
}

@media (max-width: 575.98px) {
  .afp-cookie-content {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
}

.afp-cookie-fade-enter-active,
.afp-cookie-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.afp-cookie-fade-enter-from,
.afp-cookie-fade-leave-to {
  opacity: 0;
  transform: translateY(1rem);
}
</style>
